export default __webpack_public_path__ + "static/clutch-76712febf4d25ed5212487f92c92b445.png";